import { css } from 'emotion'

const icon = (point, deleteActiveCondition) => {
  return css`
    opacity: ${point.toDelete ? 0.3 : 1};
    visibility: ${deleteActiveCondition ? 'visible' : 'hidden'};
  `
}

export default { icon }
